import type { MessagingCreateChatRoom201BasicInfo } from './messagingCreateChatRoom201BasicInfo';
import type { MessagingCreateChatRoom201LastMessage } from './messagingCreateChatRoom201LastMessage';
import type { MessagingCreateChatRoom201ParticipantsItem } from './messagingCreateChatRoom201ParticipantsItem';
import type { MessagingCreateChatRoom201TimeInfo } from './messagingCreateChatRoom201TimeInfo';

export type MessagingCreateChatRoom201 = {
  basicInfo?: MessagingCreateChatRoom201BasicInfo;
  /** 마지막 메시지 */
  lastMessage?: MessagingCreateChatRoom201LastMessage;
  /** 참여자 목록 */
  participants?: MessagingCreateChatRoom201ParticipantsItem[];
  /** 시간 관련 정보 */
  timeInfo?: MessagingCreateChatRoom201TimeInfo;
};
